/**
 * External dependencies
 */
import { get } from 'lodash';
import jwtDecode from 'jwt-decode';

/**
 * Internal dependencies
 */
import Emitter from 'lib/mixins/emitter';


function User() {
    if (!(this instanceof User)) {
        return new User();
    }
    this.initialize();
}

Emitter(User.prototype);

/**
 * Initialize the user data depending on the configuration
 **/
User.prototype.initialize = async function() {
    this.fetching = false;
    this.initialized = false;
    await this.fetch();
};

User.prototype.get = function() {
    if (!this.data) {
        this.fetch();
    }
    return this.data;
};

User.prototype.clear = async function() {
    this.data = null;
    await localStorage.clear();
};

User.prototype.setData = function(user) {
    this.data = user;
};

User.prototype.getData = function() {
    return this.data;
};

User.prototype.fetch = function() {
    if (this.fetching) {
        return;
    }
	this.fetching = false;
    try {
        let user = jwtDecode(localStorage.getItem('currentUserJWT'));
        this.data = user;
        this.initialized = true;
    } catch (error) {
        this.initialized = true;
        this.clear();
    }
    
    this.emit('change');
};

User.prototype.refresh = function() {};

User.prototype.getProfileImageLink = function() {
    return get(this.data, ['attributes', 'custom:profile_image']);
};

export default User;
